<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-dialog 
      v-model="dialog.map" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-text class="pa-5">
          <gmap-map
            :center="center"
            :zoom="15"
            :clickable="true"
            @click="updatePlace"
            class="_maps"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            }">

            <gmap-marker
              :position="center"
              :draggable="true"
              @drag="updatePlace"
              @click="center=center">
            </gmap-marker>
          </gmap-map>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            width="150"
            elevation="3"
            :color="style.primary"
            class="text-capitalize white--text mx-1"
            @click="dialog.map = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Terapkan
          </v-btn>
          <v-btn 
            text 
            color="red"
            class="text-capitalize white--text"
            @click="dialog.map = false; form.address = ''; form.detail.coordinate = {
              latitude: '',
              longitude: ''
            };">
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="end">
      <v-col>
        <ul class="steps mb-5">
          <li class="current">
            <a href="#" title="" class="caption d-flex align-center">
              <v-icon color="white" small class="mr-1">mdi-home-edit-outline</v-icon>
              Informasi Proyek
            </a>
          </li>
          <li>
            <a href="#" title="" class="caption text-third d-flex align-center">
              <v-icon color="#B2B2B2" small class="mr-1">mdi-home-plus-outline</v-icon>
              Jenis / Tipe / Unit
            </a>
          </li>
        </ul>
        <v-card
          class="border-radius box-shadow pa-5">
          <v-row>
            <v-col cols="12" md="6">
              <v-card-text>
                <ValidationObserver ref="observer">
                  <v-form>
                    <ValidationProvider v-if="user.company_type === 'external'"
                      name="Pilih Paket" rules="required" v-slot="{ errors }">
                      <v-select
                        dense
                        outlined
                        single-line
                        label="Pilih Paket"
                        :color="style.primary"
                        prepend-inner-icon="mdi-cash-check"
                        :items="config.schema"
                        item-value="schema_id"
                        item-text="schema_label"
                        item-color="light-green lighten-2"
                        v-model="form.schema_id"
                        :error-messages="errors"
                        require>
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                        <template slot="selection" slot-scope="data">
                          {{ data.item.schema_label }} 
                          <span class="text-second mx-2">({{ data.item.schema_quota_min }} - {{ data.item.schema_quota_max }} Unit)</span>
                          <!-- <span class="ml-2" v-if="parseInt(data.item.schema_price) > 0">
                            {{ parseInt(data.item.schema_price) | price }}
                          </span>
                          <span class="ml-2" v-else>
                            Gratis
                          </span> -->
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.schema_label }} 
                          <span class="text-second mx-2">({{ data.item.schema_quota_min }} - {{ data.item.schema_quota_max }} Unit)</span> 
                          <!-- <span class="ml-2" v-if="parseInt(data.item.schema_price) > 0">
                            {{ parseInt(data.item.schema_price) | price }}
                          </span>
                          <span class="ml-2" v-else>
                            Gratis
                          </span> -->
                        </template>
                      </v-select>
                    </ValidationProvider>

                    <!--
                    <v-alert v-if="form.schema_id !== ''"
                      outlined
                      type="info"
                      :color="style.primary"
                      text>
                      {{ schema_desc }}
                    </v-alert>
                    -->

                    <v-row>
                      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12:6" class="py-0">
                        <ValidationProvider name="Jumlah Unit" rules="required" v-slot="{ errors }">
                          <v-text-field
                            dense
                            outlined
                            single-line
                            class="text-field"
                            label="Jumlah Unit"
                            :color="style.primary"
                            prepend-inner-icon="mdi-home-outline"
                            v-model="form.unit_quota"
                            :error-messages="errors"
                            type="number"
                            :min="form.unit_quota_min"
                            :max="form.unit_quota_max"
                            @change="calc_unit_quota()"
                            require>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12:6" class="py-0" style="margin-top: 10px;">
                        Unit
                      </v-col>
                    </v-row> 

                    <v-alert v-if="form.schema_id !== ''"
                      outlined
                      type="info"
                      :color="style.primary"
                      text>
                      {{ form.unit_quota_pricing | price}}
                    </v-alert>

                    <ValidationProvider name="Nama Proyek" rules="required" v-slot="{ errors }">
                      <v-text-field
                        dense
                        outlined
                        single-line
                        class="text-field"
                        label="Nama Proyek"
                        :color="style.primary"
                        prepend-inner-icon="mdi-home-edit-outline"
                        v-model="form.name"
                        :error-messages="errors"
                        require>
                      </v-text-field>
                    </ValidationProvider>
                    <ValidationProvider name="Kategori" rules="required" v-slot="{ errors }">
                      <v-select
                        dense
                        outlined
                        single-line
                        label="Kategori"
                        :color="style.primary"
                        prepend-inner-icon="mdi-tag-multiple-outline"
                        :items="config.category"
                        item-value="project_category_id"
                        item-text="project_category_name"
                        item-color="light-green lighten-2"
                        v-model="form.category_id"
                        :error-messages="errors"
                        require>
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                      </v-select>
                    </ValidationProvider>
                    <v-row>
                      <v-col cols="10" class="py-0 pr-0">
                        <div class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                          <div class="v-input__control">
                            <div class="v-input__slot">
                              <div class="v-input__prepend-inner">
                                <div class="v-input__icon v-input__icon--prepend-inner">
                                  <i aria-hidden="true" class="v-icon notranslate mdi mdi-home-map-marker theme--light"></i>
                                </div>
                              </div>
                              <fieldset aria-hidden="true">
                                <legend style="width: 0px;">
                                  <span>​</span>
                                </legend>
                              </fieldset>
                              <div class="v-text-field__slot">
                                <label for="input-147" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
                                  <!-- Alamat / Lokasi Proyek -->
                                </label>
                                <gmap-autocomplete placeholder="Alamat / Lokasi Proyek" :value="form.address" :select-first-on-enter="true" @place_changed="setPlace"></gmap-autocomplete>
                              </div>
                            </div>
                            <div class="v-text-field__details">
                              <div class="v-messages theme--light">
                                <div class="v-messages__wrapper">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="2" class="py-0"
                        :style="$vuetify.breakpoint.name === 'xs' ? 'position:relative; left: -30px;':'position:relative; left: -47px;'">
                        <v-btn
                          style="border-radius: 0px 4px 4px 0px;"
                          height="40"
                          elevation="0"
                          color="grey"
                          class="text-capitalize white--text"
                          @click="dialog.map = true">
                          <span   v-if="$vuetify.breakpoint.name !== 'xs'">Pilih Dari Peta</span>
                          <v-icon v-if="$vuetify.breakpoint.name === 'xs'">mdi-google-maps</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12:6" class="py-0">
                        <ValidationProvider name="Pilih Provinsi" rules="required" v-slot="{ errors }">
                          <v-select
                            dense
                            outlined
                            single-line
                            label="Pilih Provinsi"
                            :color="style.primary"
                            prepend-inner-icon="mdi-map-marker"
                            :items="config.province"
                            item-value="province_id"
                            item-text="province_name"
                            item-color="light-green lighten-2"
                            v-model="form.province_id"
                            :error-messages="errors"
                            require>
                            <template v-slot:append>
                              <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                            </template>
                          </v-select>
                        </ValidationProvider>
                      </v-col>
                      <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 12:6" class="py-0">
                        <ValidationProvider name="Pilih Kabupaten" rules="required" v-slot="{ errors }">
                          <v-select
                            dense
                            outlined
                            single-line
                            label="Pilih Kabupaten"
                            :color="style.primary"
                            prepend-inner-icon="mdi-map-marker"
                            :items="config.city"
                            item-value="city_id"
                            item-text="city_name"
                            item-color="light-green lighten-2"
                            v-model="form.city_id"
                            :error-messages="errors"
                            require>
                            <template v-slot:append>
                              <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                            </template>
                          </v-select>
                        </ValidationProvider>
                      </v-col>
                    </v-row>                      
                    <ValidationProvider name="Pilih Fasilitas Umum" rules="required" v-slot="{ errors }">
                      <v-autocomplete
                        chips
                        multiple
                        dense
                        outlined
                        single-line
                        label="Pilih Fasilitas Umum"
                        :color="style.primary"
                        hide-details
                        clearable
                        prepend-inner-icon="mdi-timeline-check-outline"
                        :items="config.facility"
                        item-value="facility_id"
                        item-text="facility_name"
                        return-object
                        v-model="form.detail.facility"
                        :error-messages="errors"
                        require>
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            class="ma-1"
                            color="#B2B2B2"
                            text-color="white"
                            @click="data.select"
                            @click:close="removeFacility(data.item)">
                            {{ data.item.facility_name }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.facility_name"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                    <p class="caption pt-2" v-if="!addFacility">
                      <span class="text-second">
                        Tambah fasilitas jika diatas tidak ada
                      </span>
                      <router-link to="/setting/facility" target="_blank">
                        <span class="light-green--text" @click="addFacility = true">
                          Tambah disini
                        </span>
                      </router-link>
                    </p>
                    <p class="caption pt-2" v-if="addFacility">
                      <span class="text-second">
                        Silahkan refresh data yang anda tambahkan
                      </span>
                      <span class="light-green--text cursor-pointer" @click="setting().facility()">
                        Refresh disini
                      </span>
                    </p>
                    
                    <ValidationProvider name="Pilih Developer" rules="required" v-slot="{ errors }">
                      <v-autocomplete
                        chips
                        multiple
                        dense
                        outlined
                        single-line
                        label="Pilih Developer"
                        :color="style.primary"
                        clearable
                        prepend-inner-icon="mdi-timeline-check-outline"
                        :items="config.developer"
                        item-value="user_id"
                        item-text="user_name"
                        return-object
                        v-model="form.developer"
                        :error-messages="errors"
                        require>
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            class="ma-1"
                            color="#B2B2B2"
                            text-color="white"
                            @click="data.select"
                            @click:close="removeDeveloper(data.item)">
                            <v-avatar left style="min-width: 17px !important; width: 17px !important; height: 17px !important;">
                              <v-img :src="data.item.user_image_url"></v-img>
                            </v-avatar>
                            {{ data.item.user_name }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-avatar style="min-width: 20px !important; width: 20px !important; height: 20px !important;">
                              <img :src="data.item.user_image_url">
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.user_name"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                    <quill-editor 
                      ref="myTextEditor"
                      :options="option"
                      v-model="form.detail.description">
                    </quill-editor>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
            </v-col>
            <v-col cols="12" md="6" :style="$vuetify.breakpoint.name === 'xs' ? '' : 'border-left: 1px solid rgb(199, 106, 106, 0.1);'">
              <v-card-actions class="pa-0 d-flex align-center">
                <v-card-title class="body-2 text-second">
                  Gambar Rumah
                </v-card-title>
                <v-spacer/>
                <image-input class="ma-2" v-model="images">
                  <div slot="activator">
                    <v-btn
                      outlined
                      x-small
                      width="100"
                      color="green"
                      class="text-capitalize">
                      Tambah
                    </v-btn>
                  </div>
                </image-input>
                <v-btn
                  v-if="form.detail.images.length > 0"
                  outlined
                  x-small
                  width="100"
                  color="red"
                  class="text-capitalize"
                  @click="form.detail.images = []">
                  Hapus Semua
                </v-btn>
              </v-card-actions>
              <v-divider/>
              <v-card-title :class="form.detail.images.length > 3 ? 'px-0' : ''">
                <v-slide-group
                  prev-icon="mdi-chevron-left-circle"
                  next-icon="mdi-chevron-right-circle"
                  center-active
                  show-arrows>
                  <v-slide-item
                    v-for="(item, index) in form.detail.images"
                    :key="index"
                    v-slot:default="{ active, toggle }">
                    <v-card
                      class="mx-2 box-shadow"
                      width="150"
                      height="150" 
                      outlined
                      @click="toggle">
                      <v-img
                        width="150"
                        height="150" 
                        :src="item"
                        gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                        <v-icon color="white" style="position: absolute; top: 5px; right: 5px;" @click="removeImage('images', index)">mdi-close-circle</v-icon>
                      </v-img>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-card-title>
              <v-card-text class="caption text-third text-center my-12" v-if="form.detail.images.length < 1">
                Silahkan upload gambar rumah dengan klik tombol <b>"Tambah"</b> diatas.
              </v-card-text>
              <v-card-actions class="pa-0 d-flex align-center">
                <v-card-title class="body-2 text-second">
                  Gambar Site Plan
                </v-card-title>
                <v-spacer/>
                <image-input class="ma-2" v-model="siteplan">
                  <div slot="activator">
                    <v-btn
                      outlined
                      x-small
                      width="100"
                      color="green"
                      class="text-capitalize">
                      Tambah
                    </v-btn>
                  </div>
                </image-input>
                <v-btn
                  v-if="form.detail.siteplan.length > 0"
                  outlined
                  x-small
                  width="100"
                  color="red"
                  class="text-capitalize"
                  @click="form.detail.siteplan = []">
                  Hapus Semua
                </v-btn>
              </v-card-actions>
              <v-divider/>
              <v-card-title :class="form.detail.siteplan.length > 3 ? 'px-0' : ''">
                <v-slide-group
                  prev-icon="mdi-chevron-left-circle"
                  next-icon="mdi-chevron-right-circle"
                  center-active
                  show-arrows>
                  <v-slide-item
                    v-for="(item, index) in form.detail.siteplan"
                    :key="index"
                    v-slot:default="{ active, toggle }">
                    <v-card
                      class="mx-2 box-shadow"
                      width="150"
                      height="150" 
                      outlined
                      @click="toggle">
                      <v-img
                        width="150"
                        height="150" 
                        :src="item"
                        gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                        <v-icon color="white" style="position: absolute; top: 5px; right: 5px;" @click="removeImage('siteplan', index)">mdi-close-circle</v-icon>
                      </v-img>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-card-title>
              <v-card-text class="caption text-third text-center my-12" v-if="form.detail.siteplan.length < 1">
                Silahkan upload gambar site plan dengan klik tombol <b>"Tambah"</b> diatas.
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
        <v-card-text class="pt-6 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="py-5">
          <v-spacer/>
          <v-btn
            width="150"
            elevation="3"
            color="red"
            class="text-capitalize white--text"
            :disabled="process.run"
            to="/project">
            <v-icon small class="mr-1">mdi-close</v-icon>
            Batalkan
          </v-btn>
          <v-btn
            width="150"
            elevation="3"
            :color="style.primary"
            class="text-capitalize white--text"
            :loading="process.run"
            :disabled="process.run"
            @click="save">
            Selanjutnya
            <v-icon small class="ml-1">mdi-chevron-right</v-icon>
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import ImageInput from "../../../components/ImageInput.vue";
  export default {
    data () {
      return {
        dialog: {
          map: false
        },
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        config: {
          category: [],
          province: [],
          city: [],
          facility: [],
          marketing: [],
          developer: [],
          schema: []
        },
        center: {
          lat: 0,
          lng: 0
        },
        addFacility: false,
        images: false,
        siteplan: false,
        form: {
          id: '',
          category_id: '',
          category_name: '',
          company_id: '',
          name: '',
          address: '',
          province_id: '',
          province_name: '',
          city_id: '',
          city_name: '',
          published_status: 'publish',
          detail: {
            description: '',
            facility: [],
            siteplan: [],
            coordinate: {
              latitude: '',
              longitude: ''
            },
            images: []
          },
          marketing: [],
          unit_sold: 0,
          image_url: '',
          schema_id: '',
          developer: [],
          unit_quota: 0,
          unit_quota_pricing: 0,
          unit_quota_min: 0,
          unit_quota_max: 0,
          schema_data: []
        },
        schema_desc: '',
        process: {
          run: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      ImageInput
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      images: {
        handler: function () {
          if (this.images) {
            this.form.detail.images.push(this.images.url)
          }
        },
        deep: true
      },
      siteplan: {
        handler: function () {
          if (this.siteplan) {
            this.form.detail.siteplan.push(this.siteplan.url)
          }
        },
        deep: true
      },
      'form.category_id': function() {
        let t = this
        let c = this.config.category.filter(function(v) {
          return t.form.category_id == v.project_category_id
        })

        if (c.length > 0) {
          this.form.category_name = c[0].project_category_name
        }
      },
      'form.province_id': function() {
        let t = this
        let p = this.config.province.filter(function(v) {
          return t.form.province_id == v.province_id
        })

        if (p.length > 0) {
          this.form.province_name = p[0].province_name
        }

        this.setting().city()
      },
      'form.city_id': function() {
        let t = this
        let c = this.config.city.filter(function(v) {
          return t.form.city_id == v.city_id
        })

        if (c.length > 0) {
          this.form.city_name = c[0].city_name
        }
      },
      'form.schema_id': function() {
        let t = this
        let s = this.config.schema.filter(function(v) {
          return t.form.schema_id == v.schema_id
        })

        if (s.length > 0) {
          this.schema_desc = s[0].schema_desc
          this.form.schema_data = s[0]
          this.form.unit_quota_pricing = this.form.schema_data.schema_price * this.form.unit_quota
          this.form.unit_quota_min = this.form.schema_data.schema_quota_min
          this.form.unit_quota_max = this.form.schema_data.schema_quota_max

          this.form.unit_quota = this.form.schema_data.schema_quota_max
        }
      },
      'form.unit_quota': function(e) {
        //console.log(e)

        this.form.unit_quota_pricing = this.form.schema_data.schema_price * this.form.unit_quota
      }
    },
    mounted () {
      this.fetch()

  const allowedRoles = ['superuser', 'administrator']
  const hasAccess = this.user.user_company_roles_name.some(role => allowedRoles.includes(role))
  if (!hasAccess) {
    this.$router.push({ path: '/404' }) // Redirect to 404 page if no access
  }
    },
    methods: {
      fetch() {
        this.setting().category()
        this.setting().province()
        this.setting().facility()
        this.setting().marketing()
        this.setting().developer()
        this.setting().schema()

        this.getGeoLocation()
      },
      setting() {
        let t = this
        return {
          async category() {
            get(`project/category/get-list-option`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.category = res.data.results
              }
            })
          },
          async province() {
            get(`location/get-province`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.province = res.data.province
              }
            })
          },
          async city() {
            get(`location/get-city`, {
              params: { province_id: t.form.province_id }
            })
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.city = res.data.city
              }
            })
          },
          async facility() {
            get(`project/facility/get-list-option`, {
              params: {
                type: 'all,public'
              }
            })
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.facility = res.data.results
                t.addFacility = false
              }
            })
          },
          async marketing() {
            get(`auth/company/project/list-marketing`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.marketing = res.data.results
              }
            })
          },
          async developer() {
            get(`auth/developer/list`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.developer = res.data.results
              }
            })
          },
          async schema() {
            get(`auth/schema/list`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.schema = res.data.results
              }
            })
          }
        }
      },
      getGeoLocation() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        })
      },
      setPlace(place) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }

        this.form.detail.coordinate = {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng()
        }

        this.form.address = place.formatted_address
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.detail.coordinate = {
          latitude: location.latLng.lat(),
          longitude: location.latLng.lng()
        }

        const geocoder = new google.maps.Geocoder()
        geocoder.geocode({ latLng: this.center }, (result, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            this.form.address = result[0].formatted_address
          }
        })
      },
      removeFacility (item) {
        const index = this.form.detail.facility.findIndex(v => v.facility_id === item.facility_id)
        if (index >= 0) this.form.detail.facility.splice(index, 1)
      },
      removeMarketing (item) {
        const index = this.form.marketing.findIndex(v => v.user_id === item.user_id)
        if (index >= 0) this.form.marketing.splice(index, 1)
      },
      removeDeveloper (item) {
        const index = this.form.developer.findIndex(v => v.user_id === item.user_id)
        if (index >= 0) this.form.developer.splice(index, 1)
      },
      removeImage(type, index) {
        if (type === 'images') {
          this.form.detail.images.splice(index, 1)
        } else {
          this.form.detail.siteplan.splice(index, 1)
        }
      },
      async save() {
        this.error.message = ''

        this.form.company_id = this.user.company_id
        this.form.image_url = this.form.detail.images[0]
        let forms = Object.assign({}, this.form)
        forms.detail = JSON.stringify(forms.detail)
        forms.marketing = JSON.stringify(forms.marketing)
        forms.developer = JSON.stringify(forms.developer)
        
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.run = true
          await post(`auth/company/project/form`, {
            data: forms
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.$router.push({ path: `/project/unit/detail/${res.data.data_id}` })
            } else {
              this.process.run = false
              this.error.message = res.msg
            }
          })
        }
      },
      calc_unit_quota() {
       if (parseInt(this.form.unit_quota) < parseInt(this.form.unit_quota_min)) {
          //console.log(this.form.unit_quota + ' < ' + this.form.unit_quota_min)
          this.form.unit_quota = this.form.unit_quota_min
        } else if (parseInt(this.form.unit_quota) > parseInt(this.form.unit_quota_max)) {
          //console.log(this.form.unit_quota + ' > ' + this.form.unit_quota_max)
          this.form.unit_quota = this.form.unit_quota_max
        }

        this.form.unit_quota_pricing = this.form.schema_data.schema_price * this.form.unit_quota
      }
    }
  }
</script>

<style scoped>
.steps {
  margin: 0px;
  padding: 0;
  overflow: hidden;
  border-radius: 5px;
}
.steps a {
  color: white;
  text-decoration: none;
}
.steps li {
  float: left;
  margin-left: 0;
  width: 175px; /* 100 / number of steps */
  height: 45px; /* total height */
  list-style-type: none;
  padding: 12px 5px 5px 30px; /* padding around text, last should include arrow width */
  border-right: 3px solid white; /* width: gap between arrows, color: background of document */
  position: relative;
}
/* remove extra padding on the first object since it doesn't have an arrow to the left */
.steps li:first-child {
  padding-left: 15px;
}
/* white arrow to the left to "erase" background (starting from the 2nd object) */
.steps li:nth-child(n+2)::before {
  position: absolute;
  top:0;
  left:0;
  display: block;
  border-left: 20px solid white; /* width: arrow width, color: background of document */
  border-top: 22.5px solid transparent; /* width: half height */
  border-bottom: 22.5px solid transparent; /* width: half height */
  width: 0;
  height: 0;
  content: " ";
}
/* colored arrow to the right */
.steps li::after {
  z-index: 1; /* need to bring this above the next item */
  position: absolute;
  top: 0;
  right: -20px; /* arrow width (negated) */
  display: block;
  border-left: 20px solid #7c8437; /* width: arrow width */
  border-top: 22.5px solid transparent; /* width: half height */
  border-bottom: 22.5px solid transparent; /* width: half height */
  width:0;
  height:0;
  content: " ";
}

/* Setup colors (both the background and the arrow) */

/* Completed */
.steps li { background-color: var(--color-primary); }
.steps li::after { border-left-color: var(--color-primary); }

/* Current */
.steps li.current { background-color: var(--color-primary); }
.steps li.current::after { border-left-color: var(--color-primary); }

/* Following */
.steps li.current ~ li { background-color: #e2e2e2; border-right: none; }
.steps li.current ~ li::after {	border-left-color: #e2e2e2; }

/* Hover for completed and current */
.steps li:hover {background-color: #ffb74d}
.steps li:hover::after {border-left-color: #ffb74d}

._maps {
  width: 100%;
  height: 350px;
}
.quill-editor {
  /* min-width: 675px; */
}
</style>